import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ClaimHelpComponent } from '@app/shared/modals/claim-help/claim-help.component';
import { environment } from '../../../environments/environment';
import { UtilService, ErrorMessageService, LOCAL_VAR } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isLoading = false;
  queryParams: any;
  error: any;
  appname = environment.name;
  applogo = environment.logo;
  logo = environment.logo;
  fileClaim = environment.fileClaim;
  public credentials$ = new EventEmitter<Authentication.Credentials>();
  constructor(
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private errormessageservice: ErrorMessageService,
    public utilService: UtilService
  ) {
    this.route.queryParams.pipe().subscribe(params => {
      this.queryParams = params;
    });   
    this.createForm();
  }

  ngOnInit() {
    var domainconfig = JSON.parse(localStorage.getItem(LOCAL_VAR.domainconfig));
    this.applogo = "assets/images/dowc-logo-green-bg.jpg";
    this.logo = "assets/images/dowc-logo.png";
    if (domainconfig) {
      if (domainconfig.appLogo) {
        this.applogo = domainconfig.appLogo;
      }
      if (domainconfig.appLogo) {
        this.logo = domainconfig.appLogo;
      }
      if (domainconfig.appName) {
        this.appname = domainconfig.appName;
      }
    }
    this.utilService.clearMissedError();
  }

  ngAfterViewInit() {
    this.utilService.updateDomainCss();
  }

  private createForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(/^(\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)]]
    });
  }

  onSubmit() {
    this.isLoading = true;
    this.authenticationService
      .forgotPassword(this.forgotPasswordForm.value)
      .pipe(
        finalize(() => {
          this.forgotPasswordForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        (res: any) => {
          this.toastrService.info('Email sent successfully!..');
          this.forgotPasswordForm.reset();
          this.errormessageservice.clear();
          this.utilService.clearMissedError();
          this.router.navigate(['/login']);
        },
        (error: any) => {
          this.isLoading = false;
        }
      );
  }

  async openHelpPopup() {
    const modalRef = await this.modalService.open(ClaimHelpComponent);
  }
}
